import React, {Fragment} from 'react'
import CommonCounter from './CommonCounter'
import { getCodamYearsSinceFounding } from '../../constants/codamHistoryData'

const CounterOneContent = [
    {
        dataAos:"fade-up",
        dataDelay:"",
        num:150,
        text:"기업 고객 구축 완료",
        mark:"+"
    },
    {
        dataAos:"fade-up",
        dataDelay:"200",
        text:"엔터프라이즈 구축 경력",
        num: getCodamYearsSinceFounding(),
        mark:"년"
    },
    {
        dataAos:"fade-up",
        dataDelay:"300",
        num:98,
        text:"고객 재계약률",
        mark:"%"
    },
    {
        dataAos:"fade-up",
        dataDelay:"400",
        num:24,
        text:"운영 모니터링 지원",
        mark:"/7"
    },
]

const CounterOne = () => {
    return (
        <Fragment>
            <section className="counter-area pt-75 pt-lg-30 pt-lg-35 pb-lg-10">
                <div className="container custom-contianer-one theme-bg">
                    <div className="row gx-4 gx-xxl-5">
                        {CounterOneContent.map((val, i)=>(
                            <div key={i} className="col-lg-3 col-md-6 col-sm-6" data-aos="fade-up">
                                <div className="counter-style-one mb-30">
                                    <h3><span className="counter"><CommonCounter value={val.num} /></span>{val.mark}</h3>
                                    <h4>{val.text}</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default CounterOne
